import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/media-shares")({
  component: lazyRouteComponent(() => import("./-pages/admin.media-shares")),
  head: () => ({
    meta: [
      { title: "سجلّ مشاركات المكتبة · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
